import React from 'react';
import { Link } from 'react-router-dom';
import data from '../../assets/data.webp';
import servers from '../../assets/Servers2.jpg';
import cctvhik from '../../assets/cctvhik.webp'
import dahua from '../../assets/dahua.png'

const Server =()=>{

    return(
        <section className='container mx-auto px-4 md:px-0 font-nunito mt-16'>
             <div className="relative">
                <img src={data} alt="Slide 3" className="w-full h-64 md:h-80 lg:h-96 object-cover" />
                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <h2 className="text-white text-4xl lg:text-6xl font-bold text-center">Server Solutions </h2>
                </div>
            </div>
            <div className="flex flex-col md:flex-row items-center mt-8">
                <img src={servers} alt="About Us" className="w-full md:w-1/2 md:mt-0 object-cover" /> <br />
                <div className="md:ml-8 flex-1 mt-4 md:mt-0 flex-1 mr-5 text-justify">
                    <h1 className='font-bold text-center text-justify lg:text-4xl'>Server Solutions</h1>
                    <p className="mt-4 md:mt-0 text-lg md:text-xl text-justify">
                    A server is a computer or system that provides resources, data, services, or applications to other computers, called clients, over a network. Servers enable various functions, known as “services,” including data sharing, resource distribution, and computational tasks for clients. They enhance business information security by offering a robust and secure infrastructure, featuring integrated firewall protection and secure remote access to safeguard against unauthorized access.
                    </p>
                    <p className="mt-4 md:mt-0 text-lg md:text-xl text-justify">
                    Although many businesses use third-party cloud-based servers, maintaining on-site servers ensures superior performance, flexibility, and unmatched security. IBS provides a wide range of pre-configured and customizable server solutions designed to meet industry requirements. By choosing IBS, you are investing in the highest quality enterprise server solutions available.
                    </p>
                </div>
            </div> 
            <br />
                <hr />
            <br />
            <div className='md:ml-8 flex-1 mt-4 md:mt-0 flex-1 mr-5 text-justify'>
                <h1 className='font-bold text-center text-justify lg:text-4xl'>Importance of Servers for Businesses </h1><br />
                <p className="mt-4 md:mt-0 text-lg md:text-xl text-justify">
                     CCTV Security and Video Surveillance Systems offer one of the most cost-effective solutions for workplace security. Modern surveillance cameras leverage advanced technology, enabling businesses to reduce costs and risks by safeguarding assets through continuous and seamless facility monitoring.
                These affordable cameras have largely replaced expensive security guards, significantly enhancing reliability and accountability with real-time remote video surveillance. This ensures close to 100% coverage, providing businesses with peace of mind and robust protection.
                </p>
            </div><hr />
            <div className="flex flex-col md:flex-row items-center mt-8">
                <img src={cctvhik} alt="cctv" className="w-full md:w-1/3 md:mt-0 object-cover text-justify" /> <br />
                <div className="md:ml-8 flex-1 mt-4 md:mt-0 flex-1 mr-5 text-justify">
                    <h1 className='font-bold text-center text-justify lg:text-4xl'>Hikvision</h1>
                    <p className="mt-4 md:mt-0 text-lg md:text-xl text-justify">
                        Hikvision manufactures an extensive array of CCTV cameras and equipment, including IP cameras, HD analog cameras, management and analytics software, 
                        alarm systems, and various other surveillance tools. Their innovative approach to developing surveillance products has made them a staple in numerous 
                        settings, such as retail, finance, education, government, and residential sectors. 
                        Hikvision products are known for their ease of installation, ensuring that your new security system can be operational swiftly and efficiently.
                    </p>
                </div>
            </div> 
            <div className="flex flex-col md:flex-row items-center mt-8">
                <div className="md:ml-8 flex-1 mt-4 md:mt-0 flex-1 mr-5 text-justify">
                    <h1 className='font-bold text-center text-justify lg:text-4xl'>Dahua</h1>
                    <p className="mt-4 md:mt-0 text-lg md:text-xl text-justify">
                        Dahua provides crystal clear real-time and recorded images, utilizing the latest technologies such as 
                        ANPR and Face Recognition to enhance traffic and operational efficiency. Their panoramic and thermal 
                        cameras enable more effective monitoring. Dahua's extensive product portfolio includes 
                        IPC, NVR, HDCVI cameras, HCVR, PTZ cameras, and thermal cameras, catering to a wide range of security needs.
                    </p>
                </div>
                <img src={dahua} alt="cctv" className="w-full md:w-1/3 md:mt-0 object-cover text-justify" />
            </div> <br />
            <hr /><br />
            <div className="md:ml-8 flex-1 mt-4 md:mt-0 flex-1 mr-5 text-justify">
                <p className="mt-4 md:mt-0 text-lg md:text-xl text-justify">
                IBS is a trusted provider of surveillance solutions in Zambia. <span className='font-bold'> Integrated Business Solutions Ltd (IBS)</span>  offers exceptional services in CCTV camera design, installation, and maintenance. Our team of qualified professionals is dedicated to delivering top-quality service, utilizing the most competitive, innovative, and technologically advanced products to meet your security and surveillance needs.
                </p>
            </div>
            <br /><br /><br />
            <div className="flex flex-col justify-center items-center space-y-4">
                <h1 className="font-bold text-center lg:text-4xl">
                Enhance the security of your environments by choosing the right CCTV solution that suits your business need
                </h1>
                <div>
                <div>
                    <button className="rounded bg-[#023B8D] py-2 px-4 font-bold text-[#d4af37] transition-transform duration-300 hover:scale-110 hover:bg-[#013751]">
                      <Link to={'/ContactPage'}> Talk to Us</Link> 
                    </button>
                </div>
                </div>
            </div>
            </section>
           
        )
}
export default Server;